import type { FaireProductEntity } from "../../entity_types/product";

export const p_wv3vfy3df2: FaireProductEntity = {
  token: "p_wv3vfy3df2",
  type: "product",
  name: "Thank You Yellow Flowers Card",
  brandToken: "b_b7930ea2",
  brandName: "Small Adventure",
  imageUrl:
    "https://cdn.faire.com/fastly/eb8f17ea1b3ce25536ad2b0fa4be99c9b12611c5a1c0d8fe3605b678cb107c81.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/40439c81f27962dfc6e3413300dd14d501b5aaa8dcd61c23d65f6c08cb9a0df3.jpeg",
    "https://cdn.faire.com/fastly/ea745361a3d58b17a7bb7f399599ac43768cb261812a28bd8aceaf0cee78c98d.jpeg",
    "https://cdn.faire.com/fastly/ba24874f7272cd4026fe8b4d77e1a7fdce6a967c31449dcd90fc861338576631.jpeg",
  ],
  priceDollars: 3,
  description:
    "4.25 x 5.5 inch size\nComes with matching envelope\nPrinted in the USA on soft white, FSC-certified stock that is also milled in the USA\nBlank inside",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:20.430Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
